import React, { useEffect, useState } from 'react';
import {
	Dialog,
	IconButton,
	DialogTitle,
	DialogContent,
	DialogContentText,
	Box,
	Grid,
	Divider,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { toggleLoginScreen } from '../../reducers/UiReducer';
import LoginForm from '../../form/LoginForm';
const Login = ({ notify, errorF }) => {
	const dispatch = useDispatch();
	const { loginmodal } = useSelector((state) => state.ui);
	const handleClose = () => {
		dispatch(toggleLoginScreen(false));
	};

	return (
		<Dialog
			PaperProps={
				{
					// style: { minWidth: 800 },
				}
			}
			TransitionProps={{
				style: { backgroundColor: 'transparent' },
			}}
			onClose={handleClose}
			aria-labelledby='customized-dialog-title'
			xs={{
				backgroundColor: 'transparent',
				backdropFilter: 'blur(2px)',
				'&MuiDialog-paperScrollPaper': {
					borderRadius: 5,
				},
			}}
			open={loginmodal}>
			<DialogContent
				style={{
					padding: 0,
				}}>
				<LoginForm notify={notify} errorF={errorF} />
			</DialogContent>
		</Dialog>
	);
};

export default Login;
